import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { MemberLoyaltyStatus } from './member-loyalty-status.model';
import { MemberLoyaltyStatusStore } from './member-loyalty-status.store';

@Injectable({ providedIn: 'root' })
export class MemberLoyaltyStatusQuery extends Query<MemberLoyaltyStatus> {
  constructor(protected store: MemberLoyaltyStatusStore) {
    super(store);
  }

  selectMemberAveragePoints(){
      return this.select(state => state.AveragePointsBalance);
  }
}